<div class="dropdown-trigger" #triggerEl
     [style.width]="width !== undefined ? width + 'px' : null"
     [style.min-width]="minWidth !== undefined ? minWidth + 'px' : null">
  <ng-content select="[dropdownPanel]"></ng-content>
</div>

<ng-template
        cdkConnectedOverlay
        #connected="cdkConnectedOverlay"
        [cdkConnectedOverlayPanelClass]="['on-top','app-dropdown-overlay-panel']"
        [cdkConnectedOverlayOrigin]="triggerEl"
        [cdkConnectedOverlayOpen]="isOpen && !disabled"
        [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayBackdropClass]="'dropdown-overlay-backdrop'"
        (backdropClick)="close()"
        (detach)="close()"
        (attach)="onOverlayAttach()"
        [cdkConnectedOverlayOffsetY]="5"
        [cdkConnectedOverlayPositions]="positions"
>
  <div class="dropdown-content" [style.width.px]="isDropdownListFullWidth ? dropdownWidth : null"
       [class.dropdown-content--default-width]="!isDropdownListFullWidth"
  >
    <ng-content select="[dropdownContent]"></ng-content>
  </div>
</ng-template>